// Action creator which generates an enable action.
// @flow

import { ACTIONS } from '../constants';

export default function enable(pageURL: string) {
    return {
        type: ACTIONS.ENABLE_MAINTENANCE,
        pageURL
    };
}
